module.exports = __webpack_public_path__ + "img/datasource.950f6e8b.png";